import styled from '@emotion/styled';

export const Divider = styled.hr`
  background-color: rgba(255, 255, 255, 0.1) !important;
  width: 100%;
  max-width: 50rem;
`;
